//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useCallback,
} from 'react';
import { useTranslation } from 'react-i18next';

// custom pages
import Table from 'components/Table/Table';
import LoyaltyTierAuditAPI from 'apis/loyaltyTierAudit/loyaltyTierAudit';
import Context from 'context/context';
import searchIcon from 'assets/img/Search_Icon.png';
import { Styles } from './styles';

// material-ui
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import * as moment from 'moment';

// material-ui icons
import Grid from '@material-ui/core/Grid';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

//Helpers
import useDebounce from 'helpers/useDebounce';
import { blockInvalidChar } from 'helpers/blockInvalidChar';
import { dateFormat } from "helpers/dataFormat"

import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import { toast } from "react-toastify";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Card from "@material-ui/core/Card";
import Badge from "@material-ui/core/Badge";
import maxMerch from "apis/maxmerch/maxmerch";
import PrivilegeAPI from "apis/privilege/privilege";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { CSVLink } from "react-csv";
import { exportHeaders } from "./export";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Slide from "@material-ui/core/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// custom TextField
const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '##D3D3D3',
    },
    '& .MuiFormLabel-root': {
      color: '#707070',
    },
    '& .MuiInputBase-input': {
      color: '#707070',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#707070!important',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#707070!important',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#707070',
      },
      '&:hover fieldset': {
        borderColor: '#707070',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#707070',
      },
      '&.MuiOutlinedInput-root': {
        borderRadius: 20,
      },
      '&.MuiOutlinedInput-root': {
        marginTop: 0,
        borderRadius: 20,
        background: '#ededed',
      },
    },
  },
})(TextField);

export default function LoyaltyTierAudit() {
  const { getAPI, searchAPI, loyaltyTierAuditFilter, loyaltyTierAuditExport, getAllUsers, updateLoyaltyTierAudit } = LoyaltyTierAuditAPI();
  const { state, dispatch } = useContext(Context);
  const { getTier } = maxMerch();
  const { getReasonDescription1 } = PrivilegeAPI()
  const classes = Styles();
  const [data, setData] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const { t, i18n } = useTranslation();
  const [filterCard, setFilterCard] = useState(false);
  const [response, setResponse] = useState({
    filter: false,
  });
  const [selectedOrg, setSelectedOrg] = useState({});
  const [selectedSales, setSelectedSales] = useState({});
  const [salesCategory, setSalesCategory] = useState([]);
  const [org, setOrg] = useState([]);
  const [isLoading, setIsLoading] = useState(false);



  let searchBounceValues = useDebounce(() => {
    return searchValue === '' ? '' : searchValue;
  });

  // Common State Object
  const [states, setstates] = useState({
    clearSearch: false,
    tier: [],
    reasonDescription: [],
    newTier: "",
    systemManaged: "",
    reason: "",
    editObj: {},
    updateObj: {},
    oldTier: "",
    initiatedBy: "",
    updatedBy: "",
    userDetail: []
  });

  const [open, setOpen] = useState(false);

  const [selectedAccount, setSelectedAccount] = useState({
    id: '',
    startDate: null,
    endDate: null,
    loyaltyId: '',
  })

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { clearSearch, tier, reasonDescription, userDetail, editObj, updateObj } = states;

  // Page Path Name
  useEffect(() => {
    dispatch({
      type: 'SET_PATHNAME',
      payload: ['HOME', 'ADMIN', 'Member Tier Audit'],
    });
    handleGetTier();
    handleGetReason();
    handleGetUser();
  }, []);

  // Handling Get and Search API
  useEffect(() => {
    if (!clearSearch) {
      if (searchBounceValues && searchBounceValues.length > 0) {
        handleSearch();
      }
      else if (states.filter) {
        handleFilter()
      }
      else {
        getDetails();
      }
    }
    else {
      setStates({ clearSearch: false });
    }
  }, [searchBounceValues, offset]);

  // Get API Func
  async function getDetails() {
    try {
      setLoading(true);
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setLoading(false);
        dispatch({ type: 'SET_LOADING', payload: false });
      }
    }
    catch (e) {
      console.log({ e });
    }
  }
  const handleGetReason = async () => {
    try {
      let res = await getReasonDescription1();
      if (res) {
        setStates({ reasonDescription: res.data });
      }
    }
    catch (e) {
      console.log({ e });
    }
  };
  const handleGetUser = async () => {
    try {
      let res = await getAllUsers();
      if (res) {
        setStates({ userDetail: res.data });
      }
    }
    catch (e) {
      console.log({ e });
    }
  };
  const handleGetTier = async () => {
    try {
      let res = await getTier();
      if (res) {
        setStates({ tier: res.data });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // Search API Func
  async function handleSearch() {
    try {
      setLoading(true);
      let values;
      values = {
        search: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      setFilterCard(false);
      setResponse({ ...response, filter: false });
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await searchAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setLoading(false);
        dispatch({ type: 'SET_LOADING', payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  }
  const handleFilter = async () => {
    setStates({ filter: true });
    setSearchValue("");
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };

      if (states?.startDate == "Invalid Date" || states?.endDate == "Invalid Date") {
        toast.error("Invalid Date Format");
        setFilterCard(false);
        setResponse({ filter: true });
        setStates({ editObj: "" })
        dispatch({ type: "SET_LOADING", payload: false });
        return;
      }
      if (states?.newTier) {
        values = { ...values, newTier: states?.newTier };
      }
      if (states?.oldTier) {
        values = { ...values, oldTier: states?.oldTier };
      }
      if (states?.reason) {
        values = { ...values, reason: states?.updateObj };
      }
      if (states?.startDate) {
        values = {
          ...values,
          startDate: states?.startDate
        };
      }
      if (states?.endDate) {
        values = {
          ...values,
          endDate: states?.endDate,
        };
      }
      if (states?.systemManaged) {
        values = { ...values, systemManaged: states?.systemManaged };
      }
      if (states?.initiatedBy) {
        values = { ...values, initiatedBy: states?.initiatedBy };
      }
      if (states?.updatedBy) {
        values = { ...values, updatedBy: states?.updatedBy };
      }
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await loyaltyTierAuditFilter(values);
      if (res.data.length > 0) {
        setData(res.data);
        setCount(res.count);
        setFilterCard(false);
        setResponse({ filter: true });
        setStates({ editObj: "" })
        dispatch({ type: "SET_LOADING", payload: false });
      }
      else {
        setData([]);
        setFilterCard(false);
        setResponse({ filter: true });
        setStates({ editObj: "" })
        dispatch({ type: "SET_LOADING", payload: false });
        toast.success(t("No Data Found"), { toastId: "no-report-date" });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleUpdate = async () => {
    try {
      let values = { loyaltyId: '', id: '' };

      console.log(selectedAccount, "select")

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await updateLoyaltyTierAudit(selectedAccount);
      dispatch({ type: "SET_LOADING", payload: false });
      if (res) {
        toast.success("Updated", { tostId: "update-success" });
        setOpen(false);
        getDetails()

      }
    } catch (e) {
      console.log("errors");
    }
  };

  // export api function
  const handleExport = async () => {
    let values;
    if (searchValue) {
      values = { ...values, searchValue };
    }
    if (states?.newTier) {
      values = { ...values, newTier: states?.newTier };
    }
    if (states?.oldTier) {
      values = { ...values, oldTier: states?.oldTier };
    }
    if (states?.reason) {
      values = { ...values, reason: states?.updateObj };
    }
    if (states.oldTier) {
      values = { ...values, oldTier: states.oldTier };
    }
    if (states.reason) {
      values = { ...values, reason: states.updateObj };
    }
    if (states.startDate) {
      values = {
        ...values,
        startDate: states?.startDate
      };
    }
    if (states.endDate) {
      values = {
        ...values,
        endDate: states?.endDate,
      };
    }
    if (states?.systemManaged) {
      values = { ...values, systemManaged: states?.systemManaged };
    }
    if (states?.initiatedBy) {
      values = { ...values, initiatedBy: states?.initiatedBy };
    }
    if (states?.updatedBy) {
      values = { ...values, updatedBy: states?.updatedBy };
    }
    dispatch({ type: "SET_LOADING", payload: true });
    setIsLoading(true);
    let res = await loyaltyTierAuditExport(values);
    if (res && res.data) {
      let exportdata = (res?.data).map(obj => {
        return {
          ...obj,
          start_date: obj?.start_date ? moment(obj?.start_date).format("MMM-DD-YYYY") : '-',
          end_date: obj?.end_date ? moment(obj?.end_date).format("MMM-DD-YYYY") : '-'

        }
      }
      )
      setExportData(exportdata);
      dispatch({ type: "SET_LOADING", payload: false });
      setIsLoading(false);
      if (res.data.length === 0) {
        toast.success(t("No Data Found"), { toastId: "no-report-date" });
        return false;
      }
      return true;
    }
  };

  // Data Table Headings
  let tableHeading = [
    'Member ID',
    'Old Tier',
    'New Tier',
    'System Managed',
    'Start Date',
    'End Date',
    'Initiated By',
    'Updated By',
    'Reason',
    '',
    ''
  ];

  // Table Pagination Func
  const handlePagination = (value) => {
    setOffset(value);
  };
  console.log(state, 'raja')
  return (
    <Fragment>
      <Grid item xs={12} sm={12} lg={12} className={classes.topGrid}>
        <div style={{ flex: 0.99 }}>
          <CssTextField
            id="search"
            placeholder="Search for Member ID"
            onKeyDown={blockInvalidChar}
            type={"number"}
              onWheel={(e) => e.target.blur()}
            variant="outlined"
            autoComplete="off"
            className={classes.searchInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {searchValue.length > 0 ? (
                    <CloseOutlinedIcon
                      className={classes.searchInputIcon}
                      onClick={() => {
                        setStates({ clearSearch: true });
                        setSearchValue("");
                        if (offset === 1) {
                          getDetails();
                        }
                        else {
                          setOffset(1);
                        }
                      }}
                    />
                  ) : (
                    <img
                      src={searchIcon}
                      alt=""
                      width="20px"
                      className={classes.searchInputIcon}
                    />
                  )}
                </InputAdornment>
              ),
            }}
            value={searchValue}
            onChange={(e) => {
              e.target.value.replace(/\s+/g, "").length == 0
                ? setSearchValue("")
                : setSearchValue(e.target.value);
              setOffset(1);
              if (e.target.value.length == 0) {
                getDetails();
              }
            }}
            onClick={() => { }}
          />
          <Button
            className={`${classes.filterBtn} dash-1-filter-btn`}
            onClick={() => {
              setFilterCard(!filterCard);
              if (!states.filter) {
                setStates({
                  systemManaged: "",
                  startDate: null,
                  endDate: null,
                  newTier: "",
                  reason: "",
                  oldTier: "",
                  initiatedBy: "",
                  updatedBy: ""
                });
              }
            }}
          >
            Filter
            {response["filter"] && (
              <Badge
                badgeContent={count == 0 ? null : response["filter"] && count}
                color="error"
                classes={{ badge: classes.badge }}
                max={999999}
                className={classes.badges}
              ></Badge>
            )}
          </Button>
        </div>
        <CSVLink
          id="csv"
          data={exportData}
          headers={exportHeaders.map((head) => head)}
          filename={`Loyalty-Tier-Audit-` + moment(new Date()).format("MM-DD-YYYY,h:mm A") + ".csv"}
          className={classes.CSVlink}
        />
        <button
          disabled={isLoading}
          className={classes.exportBtn}
          onClick={async () => {
            let res = await handleExport();
            if (res) {
              document.getElementById("csv").click();
            }
          }}
        >
          {isLoading ? (
            <div class="snippet" style={{ marginLeft: 55 }}>
              <div class="stage">
                <div class="dot-typing-e"></div>
              </div>
            </div>
          ) :
            `Export`
          }
        </button>
      </Grid>
      {filterCard && (
        <div className={classes.filterCardDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ float: "right" }}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={2}
                  className={classes.filterCardGridContainer}
                >
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("New Tier")}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.newTier}
                      onChange={(e) => {
                        setStates({ newTier: e.target.value });
                      }}
                    >
                      {tier?.length > 0 &&
                        tier?.map((t) => (
                          <MenuItem value={t?.tier}>
                            {t?.tier}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("Old Tier")}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.oldTier}
                      onChange={(e) => {
                        setStates({ oldTier: e.target.value });
                      }}
                    >
                      {tier?.length > 0 &&
                        tier?.map((t) => (
                          <MenuItem value={t?.tier}>
                            {t?.tier}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>
                  <Grid item sm={3} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("Start Date")}</div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="dense"
                        id="date-picker-inline"
                        className={classes.dateInput}
                        value={states.startDate}
                        maxDate={new Date()}
                        onChange={(date) => {
                          if (moment(moment(date).format("MM/DD/YYYY")).isAfter(moment(states.endDate).format("MM/DD/YYYY"))) {
                            toast.error(
                              "Start date should be lesser than End date.",
                              {
                                toastId: "start-date-end-date",
                              }
                            );
                            setStates({ startDate: null });
                            return;
                          }
                          setStates({ startDate: date, dateApplied: true });
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        autoOk
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item sm={3} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("End Date")}</div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="MM/dd/yyyy"
                        margin="dense"
                        id="date-picker-inline2"
                        className={classes.dateInput}
                        value={states.endDate}
                        onChange={(date) => {
                          if (moment(moment(date).format("MM/DD/YYYY")).isBefore(moment(states.startDate).format("MM/DD/YYYY"))) {
                            toast.error(
                              "End date should be greater than Start date.",
                              {
                                toastId: "start-date-end-date",
                              }
                            );
                            setStates({ endDate: null });
                            return;
                          }
                          setStates({ endDate: date, dateApplied: true });
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        autoOk
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("Initiated By")}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.initiatedBy}
                      onChange={(e) => {
                        setStates({ initiatedBy: e.target.value });
                      }}
                    >
                      <MenuItem value="User">User</MenuItem>
                      <MenuItem value="System">System</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item sm={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("System Managed")}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.systemManaged}
                      onChange={(e) => {
                        setStates({ systemManaged: e.target.value });
                      }}
                    >
                      <MenuItem value="YES">YES</MenuItem>
                      <MenuItem value="NO">NO</MenuItem>
                      <MenuItem value="TEMP">TEMP</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item sm={4} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("Reason")}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.reason}
                      onChange={(e) => {
                        if (e.target.value === "Others") {
                          setStates({
                            editObj: {
                              ...editObj,
                              tierReason: e.target.value,
                            },
                            updateObj: { ...updateObj, tierReason: "" },
                            reason: e.target.value
                          });
                        }
                        else {
                          setStates({
                            editObj: {
                              ...editObj,
                              tierReason: e.target.value,
                            },
                            updateObj: { ...updateObj, tierReason: e.target.value },
                            reason: e.target.value
                          });
                        }
                      }}
                    >
                      {reasonDescription?.length > 0 &&
                        reasonDescription?.map((r) => (
                          <MenuItem value={r?.reason_description}>
                            {t(r?.reason_description)}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>
                  <Grid item sm={4} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("Updated By")}</div>
                    {/* <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={states.updatedBy}
                      onChange={(e) =>  {                        
                        setStates({
                          updatedBy: e.target.value
                        });                        
                      }}
                    > 
                     {userDetail?.length > 0 &&
                      userDetail?.map((t) => (
                        <MenuItem value={t?.email}>
                          {t?.email}
                        </MenuItem>
                      ))}
                    </TextField> */}
                    <CssTextField
                      id="reason"
                      type={"text"}
                      autoComplete="off"
                      variant="outlined"
                      inputProps={{
                        maxLength: 120,
                      }}
                      value={states.updatedBy}
                      onChange={(e) => {
                        setStates({
                          updatedBy: e.target.value
                        });
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    sm={2}
                    xs={12}
                    className={classes.filterCardBtnGrid}
                  >
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <Button
                          className={classes.filterCardApplyBtn}
                          onClick={() => {
                            if (
                              !states?.reason &&
                              !states?.newTier &&
                              !states?.systemManaged &&
                              !states.startDate &&
                              !states.endDate &&
                              !states.oldTier &&
                              !states.initiatedBy &&
                              !states.updatedBy
                            ) {
                              toast.error("Please select atleast one field.");
                              return;
                            }
                            if (!states.redemptionTo && states.redemptionFrom) {
                              toast.error("Please select To column");
                              return;
                            }
                            if (states.redemptionTo && !states.redemptionFrom) {
                              toast.error("Please select From column");
                              return;
                            }
                            handleFilter();
                            setCount(0);
                            setOffset(1);
                            setResponse({ filter: false });
                          }}
                        >
                          {t("Apply")}
                        </Button>
                      </Grid>
                      {states.filter && (
                        <Grid item xs={12}>
                          <Button
                            className={classes.filterCardResetBtn}
                            onClick={() => {
                              setStates({
                                filter: false,
                                newTier: "",
                                startDate: null,
                                endDate: null,
                                systemManaged: "",
                                reason: "",
                                editObj: "",
                                updateObj: "",
                                oldTier: "",
                                initiatedBy: "",
                                updatedBy: ""
                              });
                              setOffset(1);
                              setFilterCard(false);
                              setSelectedOrg({});
                              setSelectedSales({});
                              getDetails();
                              setCount(0);
                              setResponse({ filter: false });
                            }}
                          >
                            {t("Reset")}
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                  {editObj.tierReason === "Others" && (
                    <Fragment>
                      <div className={classes.subParentText}>
                        Type the Reason&nbsp;<span style={{ color: "red" }}>*</span>
                        &nbsp;
                        <span style={{ fontSize: 12 }}>(Max 120 Characters)</span>
                      </div>
                      <CssTextField
                        id="reason"
                        type={"text"}
                        autoComplete="off"
                        variant="outlined"
                        inputProps={{
                          maxLength: 120,
                        }}
                        className={classes.dialogInput}
                        value={updateObj?.tierReason}
                        onChange={(e) => {
                          setStates({
                            updateObj: { ...updateObj, tierReason: e.target.value }
                          });
                        }}
                      />
                    </Fragment>
                  )}
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </div>
      )}

      <div style={{ marginTop: 20 }}>
        {!loading ? (
          <Table
            headings={tableHeading.map((i) => {
              return <div key={t(i)}>{t(i)}</div>;
            })}
            data={
              data?.map((d, i) => [
                d?.loyalty_id,
                t(d?.old_tier),
                t(d?.new_tier),
                t(d?.['Loyalty_Account.system_managed']),
                d?.start_date
                  ? dateFormat(d?.start_date, i18n.language)
                  : '-',
                d?.end_date
                  ? dateFormat(d?.end_date, i18n.language)
                  : '-',
                d?.altered_by,
                <div style={{ wordBreak: 'break-all' }}>
                  {d?.['User.email']}
                </div>,
                d?.reason,
                state?.userInfo?.role == "IT Admin" && <Button
                  className={`${classes.filterBtn} dash-1-filter-btn`}
                  onClick={() => {
                    setOpen(true);
                    setSelectedAccount({
                      ...selectedAccount,
                      loyaltyId: d?.loyalty_id,
                      id: d?.id,
                      startDate: d?.start_date,
                      endDate: d?.end_date
                    })
                  }}
                >
                  Edit
                </Button>,
              ])
            }
            offset={offset}
            count={
              (count / 10) % 1 == 0
                ? Math.floor(count / 10)
                : Math.floor(count / 10 + 1)
            }
            handlePagination={handlePagination}
          />
        ) : (
          <div
            style={{
              height: '25vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <h2>{t('Loading...')}</h2>
          </div>
        )}
      </div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpen(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <span
              style={{ float: "right", color: "red", cursor: "pointer" }}
              onClick={() => {
                setOpen(false)
              }}
            >
              X
            </span>            
            <div style={{ fontSize: 16, color: "#000", padding: "20px" }}>
              <h2>LoyaltyId: {selectedAccount?.loyaltyId}</h2>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    label="Start Date"
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="dense"
                    id="date-picker-inline"
                    className={classes.dateInput}
                    value={selectedAccount.startDate}                    
                    onChange={(date) => {
                      if (selectedAccount.endDate) {
                        if (moment(moment(date).format("MM/DD/YYYY")).isAfter(moment(selectedAccount.endDate).format("MM/DD/YYYY"))) {
                          toast.error("Start date should be lesser than End date.", {
                            toastId: "start-date-end-date",
                          });
                          setSelectedAccount({ ...selectedAccount, startDate: null });
                          return;
                        }
                        setSelectedAccount({ ...selectedAccount, startDate: date })
                        return;
                      }
                      setSelectedAccount({ ...selectedAccount, startDate: date })
                      return;
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    autoOk
                  />
                </MuiPickersUtilsProvider>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    label="End Date"
                    format="MM/dd/yyyy"
                    margin="dense"
                    id="date-picker-inline"
                    className={classes.dateInput}
                    value={selectedAccount.endDate}                    
                    onChange={(date) => {
                      if (date) {
                        if (moment(moment(date).format("MM/DD/YYYY")).isBefore(moment(selectedAccount.startDate).format("MM/DD/YYYY"))) {
                          toast.error("End date should be greater than Start date.", {
                            toastId: "start-date-end-date",
                          });
                          setSelectedAccount({ ...selectedAccount, endDate: null });
                          return;
                        }
                        setSelectedAccount({ ...selectedAccount, endDate: date })
                        return;
                      }
                      setSelectedAccount({ ...selectedAccount, endDate: date })
                      return;
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    autoOk
                  />
                </MuiPickersUtilsProvider>
              </div>
              <div style={{ textAlign: "center" }}>
                <button
                  className={classes.cancelBtn}
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  {t('Cancel')}
                </button>

                <button
                  className={classes.sendBtn}
                  onClick={() => {
                    handleUpdate()

                  }}                
                >
                  {t('Update')}
                </button>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}
